import * as React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Timetable } from 'timetable-model';
import { Display, IsAllowed, NavIconContainer, PageTitle, QuerySingle, Section } from 'gossamer-front-end';
import { Button, Stack } from 'react-bootstrap';

export const TimetableDisplay = (): React.JSX.Element => {
  const params = useParams();

  return (
    <>
      <NavIconContainer entityId={Timetable.id} />
      <PageTitle verb="Display" entity={Timetable} keyValue={params.key} />
      <Section>
        <QuerySingle entity={Timetable} keyValue={params.key} render={Display} />
        <IsAllowed entity={Timetable} action="update">
          <Stack direction="horizontal" gap={2}>
            <Link to={`/admin/timetable/update/${params.key}`}>
              <Button size="sm" variant="primary">
                Update
              </Button>
            </Link>
            <Link to={`/admin/timetable/amend/${params.key}`}>
              <Button size="sm" variant="primary">
                Amend
              </Button>
            </Link>
          </Stack>
        </IsAllowed>
      </Section>
    </>
  );
};
